angular.module('qkr').controller('legacyController', ($scope, $rootScope, legacyService, FormHelper, messageService,
                                                      merchantService, outletService, gettextCatalog, storefrontObserverService) => {
    // Help with errors and validation
    const formHelper = new FormHelper($scope);

    const vm = $scope;

    vm.otherlegacyform = {};
    vm.stickersheetform = {};
    
    vm.initGeneralLegacy = function() {
        legacyService.loadOtherQkrConfig().then((promise) => {
            vm.otherlegacyform = angular.copy(promise);
            vm.otherlegacyform.allowedReBuy = promise.allowedReBuy;
            vm.otherlegacyform.beneficiariesNeededMsg = promise.beneficiariesNeededMsg;
            vm.otherlegacyform.defaultScanId = promise.defaultScanId;
            vm.otherlegacyform.hideFromNearby = promise.hideFromNearby;
            vm.otherlegacyform.noFeedback = promise.noFeedback;
            vm.otherlegacyform.receiptName = promise.receiptName;
            vm.otherlegacyform.receiptFooter = promise.receiptFooter;
            vm.otherlegacyform.receiptHeader = promise.receiptHeader;
            vm.otherlegacyform.skipOutOfStockItems = promise.skipOutOfStockItems;
            vm.otherlegacyform.thankYouMessage = promise.thankYouMessage;
            vm.otherlegacyform.useShortCode = promise.useShortCode;
            vm.otherlegacyform.proximityWarning = promise.proximityWarning;
            vm.otherlegacyform.proximityLimit = promise.proximityLimit;
            vm.otherlegacyform.disableProductPushNotifications = promise.disableProductPushNotifications;
            vm.otherlegacyform.showForum = promise.showForum;

            vm.otherLegacyLoaded = true;
        });
    };
    
    vm.initStickerSheet = function() {
        legacyService.loadStickerSheetConfig().then((promise) => {
            vm.stickersheetform = angular.copy(promise);
            vm.stickersheetform.template = promise.template;
            vm.stickersheetform.maximumFontSize = promise.maximumFontSize;
            vm.stickersheetform.minimumFontSize = promise.minimumFontSize;
            vm.stickersheetform.headerLineFontIncrement = promise.headerLineFontIncrement;
            vm.stickersheetform.lineGap = promise.lineGap;
            vm.stickersheetform.showOptionLabels = promise.showOptionLabels;
            vm.stickersheetform.capitaliseOptionLabel = promise.capitaliseOptionLabel;
            vm.stickersheetform.debugMode = promise.debugMode;
            vm.stickersheetLoaded = true;
        });
    };
    
    vm.initLegacy = function() {
        vm.initGeneralLegacy();
        vm.initStickerSheet();
    };
    
    vm.updateGeneralConfiguration = function() {
        legacyService.updateGeneralConfiguration(vm.otherlegacyform)
            .then(promise => {
                updateCallback(promise);
                refundNotification();
            })
            .catch(err => {
                vm.saving = false;
                if (err.data.message.match(/.*scanId.unique.error.*/)) {
                    messageService.errorWithReason('Scan ID must be unique, please choose another', 'Error', true);
                }
            });
        vm.saving = true;
    };

    vm.updateStickerConfiguration = function() {
        legacyService.updateStickerConfiguration(vm.stickersheetform).then((promise) => {
            updateCallback(promise);
        }, (promise) => {
            updateCallback(promise);
        });
        vm.saving = true;
    };

    vm.showStickersReport = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'legacyConfigPage.showStickersReport');
    };

    vm.hideFulfilment = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'legacyConfigPage.hideFulfilment');
    };

    function refundNotification() {
        storefrontObserverService.notify(vm.otherlegacyform.allowRefunds);
    }

    function updateCallback(promise) {
        if (formHelper.handleResponse(promise).isSuccess()) {
            vm.saving = false;
            outletService.refreshOutletInfo();
            messageService.saveAlert();
        } else {
            // An error has occurred, re-enable the button
            vm.saving = false;
            messageService.error(gettextCatalog.getString('A problem was encountered when saving. Please try again.'));
        }
    }
});



// WEBPACK FOOTER //
// ./src/controllers/legacy.controller.js